import React, { useEffect, useState } from 'react';
import IncentiveView from './Incentive.view';
import NewGameState from '../../_types/NewGameState';
import { useGetUserInformationQuery } from '../../../../../store/api/GraphQlQuery';
import getKpis from '../../../games-helpers/getKpis';

type Props = {
  newGameState: NewGameState;
  onChangeNewGameState: (newGameState: NewGameState) => void;
};

const IncentiveContainer: React.FC<Props> = ({
  newGameState,
  onChangeNewGameState,
}) => {
  const { data: userData, isLoading } = useGetUserInformationQuery({});
  const [kpis, setKpis] = useState<
    { label: string; value: string; rule: any }[]
  >([]);

  useEffect(() => {
    const fetchKpis = async () => {
      if (isLoading || !userData) {
        return;
      }

      try {
        const kpis = await getKpis({
          me: userData.me,
        });
        setKpis(kpis);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };

    fetchKpis();
  }, [isLoading, userData]);

  if (isLoading || !userData) return null;

  return (
    <IncentiveView
      newGameState={newGameState}
      onChangeNewGameState={onChangeNewGameState}
      kpis={kpis}
    />
  );
};

export default IncentiveContainer;
